export type AnnouncePoliteness = 'polite' | 'assertive';

export interface AnnounceEventDetail {
  message: string;
  politeness: AnnouncePoliteness;
}

export const ANNOUNCE_EVENT = 'a11y:announce';

// Dispatch a status message to be spoken by assistive technology via a live region
export function announce(
  message: string,
  politeness: AnnouncePoliteness = 'polite',
): void {
  if (!message.trim()) {
    return;
  }

  document.dispatchEvent(
    new CustomEvent<AnnounceEventDetail>(ANNOUNCE_EVENT, {
      detail: {message, politeness},
    }),
  );
}
